import React from "react";
import IconButton from "@material-ui/core/IconButton";
import { ReactComponent as LockIcon } from "../../../../../../../images/settings-icons/lock-icon.svg";
import { ReactComponent as LockOpenIcon } from "../../../../../../../images/settings-icons/unlock-icon.svg";
import {
  DayColumn as DayColumnStyled,
  CheckboxContainer,
  GreenCheckbox,
  DateLabel,
  DayLabel,
  CalorieValue,
  MacroStack,
  MacroBar,
} from "./styled-components";

const DayColumn = ({
  day,
  index,
  userProtein,
  percentages,
  isSelected,
  canMultiSelect,
  onDaySelect,
  onCheckboxToggle,
  onDayLock,
  getMacroFlexValue,
  isPast,
  dateLabel,
}) => {
  return (
    <DayColumnStyled
      key={index}
      selected={isSelected}
      $isPast={isPast}
      onClick={() => !isPast && onDaySelect(index)}
      style={{ cursor: isPast ? 'not-allowed' : 'pointer' }}
    >
      <CheckboxContainer
        $disabled={!canMultiSelect || isPast}
        onClick={(e) => e.stopPropagation()}
      >
        <GreenCheckbox
          checked={isSelected}
          onChange={(e) => onCheckboxToggle(index, e)}
          disabled={!canMultiSelect || isPast}
          size="small"
        />
      </CheckboxContainer>
      <DateLabel>{dateLabel}</DateLabel>
      <DayLabel>{day.name}</DayLabel>
      <CalorieValue>{Math.round(day.calories)}</CalorieValue>

      <MacroStack>
        <MacroBar
          flexValue={getMacroFlexValue(percentages.fat)}
          color="#e328a2"
          $isPast={isPast}
        >
          {Math.round(day.fat)}f
        </MacroBar>
        <MacroBar
          flexValue={getMacroFlexValue(percentages.carbs)}
          color="#5c2ff0"
          $isPast={isPast}
        >
          {Math.round(day.carbs)}c
        </MacroBar>
        <MacroBar
          flexValue={getMacroFlexValue(percentages.protein)}
          color="#ed8b2e"
          $isPast={isPast}
        >
          {Math.round(userProtein)}p
        </MacroBar>
      </MacroStack>

      <IconButton
        key={`lock-${index}`}
        aria-label={`lock-day-${index}`}
        color="inherit"
        onClick={(e) => {
          e.stopPropagation();
          // Don't allow unlocking past days
          if (!isPast) {
            onDayLock(index);
          }
        }}
        size="medium"
        disabled={isPast}
        style={{ opacity: isPast ? 0.3 : 1, cursor: isPast ? 'not-allowed' : 'pointer' }}
      >
        {day.locked ? (
          <LockIcon style={{ width: 24, height: 24 }} />
        ) : (
          <LockOpenIcon style={{ width: 24, height: 24 }} />
        )}
      </IconButton>
    </DayColumnStyled>
  );
};

export default DayColumn;

